import get from 'lodash/get';
import { hasValue } from '../../../../../../helpers';
import { transformBooleanValuesToString } from '../transformBooleanValuesToString';
import { fieldNameHasSpecialCharacters } from '../fieldNameHasSpecialCharacters';
import { replaceFieldNameSpecialCharacters } from '../replaceFieldNameSpecialCharacters';
import { PricingFormInputType } from '../../../../types/enums';

export function transformDelegateAdHocFormValues(values, adHoc) {
  const transformedValues = {};

  adHoc.sets?.forEach((adHocSet) => {
    adHocSet.formInputs.forEach((field) => {
      transformDelegateAdHocFormField(values, field, transformedValues);
    });
  });

  return {
    ...values,
    adHocAnswers: transformedValues,
  };
}

export function transformDelegateAdHocFormField(
  values,
  field,
  transformedValues,
) {
  const fieldName = field.name;
  const fullFieldName = `adHocAnswers.${field.name}`;

  switch (field.type) {
    case PricingFormInputType.TEXT:
    case PricingFormInputType.EMAIL:
    case PricingFormInputType.TELEPHONE:
    case PricingFormInputType.TEXTAREA:
    case PricingFormInputType.SELECT:
    case PricingFormInputType.DATE:
    case PricingFormInputType.DATE_MM:
    case PricingFormInputType.DATE_YY:
      {
        const value = get(values, fullFieldName);
        transformedValues[fieldName] = hasValue(value)
          ? [transformBooleanValuesToString({ value })]
          : [];
      }
      break;

    case PricingFormInputType.FILE:
    case PricingFormInputType.FILE_GROUP: {
      transformedValues[fieldName] = get(values, fullFieldName, []);
      break;
    }

    case PricingFormInputType.RADIO:
      {
        const { __radio__: radioValue, __other__: other } =
          get(values, fullFieldName) || {};
        const value = radioValue !== '__checked__' ? radioValue : undefined;
        transformedValues[fieldName] = value || other ? [{ value, other }] : [];
      }
      break;

    case PricingFormInputType.CHECKBOX_GROUP:
      transformDelegateAdHocCheckboxGroupField(
        fieldName,
        fullFieldName,
        values,
        transformedValues,
      );
      break;

    default:
      break;
  }
}

export function transformDelegateAdHocCheckboxGroupField(
  fieldName,
  fullFieldName,
  values,
  transformedValues,
) {
  const {
    __checkbox__: otherCheckboxSelected,
    __other__: other,
    ...checkboxes
  } = get(values, fullFieldName) || {};

  Object.keys(checkboxes).forEach((checkboxFieldName) => {
    if (fieldNameHasSpecialCharacters(checkboxFieldName)) {
      // Create a new correct field name
      checkboxes[replaceFieldNameSpecialCharacters(checkboxFieldName)] =
        checkboxes[checkboxFieldName];

      // Remove old redundant field name
      delete checkboxes[checkboxFieldName];
    }
  });

  const answers = Object.keys(checkboxes)
    .filter((key) => checkboxes[key] === 'true' || checkboxes[key] === true)
    .map((key) => ({
      value: key,
    }));

  if (other && otherCheckboxSelected) {
    answers.push({
      other,
    });
  }

  transformedValues[fieldName] = answers;
}
